<div class="map-container">
    <section id="map">
        <div class="map-controls">
            <!-- Sección: Categorías -->
            <div class="filter-section">
                <span class="filter-section-label">{{'MAP.CATEGORIES' | translate}}</span>
                <div class="filter-container">
                    @for (category of categories; track $index) {
                    <button class="map-button" (click)="selectedCategory(category)" id="category-{{category}}"
                        [class.active]="selectedCategories.has(category)">
                        <img class="filter-icon" [src]="'assets/icons/' + getCategoryIcon(category) + '.png'"
                            [alt]="getCategoryLabel(category)" onerror="this.style.display='none'">
                        <span class="filter-text">{{getCategoryLabel(category) | translate}}</span>
                    </button>
                    }
                </div>
            </div>

            <!-- Sección: Utilidades -->
            <div class="filter-section">
                <span class="filter-section-label">{{'MAP.UTILITIES' | translate}}</span>
                <div class="filter-container">
                    <button class="map-button" (click)="activateZoom()" [class.active]="zoom">
                        <span class="filter-text">{{zoomText}}</span>
                    </button>
                    <button class="map-button" (click)="toggleToponymy()" [class.active]="toponymyVisible()">
                        <span class="filter-text">{{'MAP.TOPONYMY' | translate}}</span>
                    </button>
                    <button class="map-button" (click)="toggleStreets()" [class.active]="streetsVisible()">
                        <span class="filter-text">{{'MAP.ROADS' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section class="map-sheets">

        <!-- Tarjeta genérica de alojamientos: solo si hay alojamientos visibles en el viewport -->
        @if (hasVisibleAlojamientos && (selectedCategories.size === 0 || selectedCategories.has('alo'))) {
        <app-card [denominacion]="'SUBLINKS.ACCOMMODATIONS' | translate" [categoria]="'alo'" [OBJECTID]="0"
            [image]="'/assets/images/cards/accommodation1.jpg'" [customRoute]="['/alojamientos']">
        </app-card>
        }

        @for (visiblePoint of visibleSidebarPoints; track visiblePoint.OBJECTID) {
        @if(visiblePoint.categoria !== 'alo'){
        <app-card [denominacion]="visiblePoint.denominacion" [categoria]="visiblePoint.categoria"
            [OBJECTID]="visiblePoint.OBJECTID" [image]="'/assets/images/cards/' + visiblePoint.OBJECTID + '.jpg'">
        </app-card>
        }
        }

    </section>

    <!-- Floating Mobile filter button -->
    <button class="mobile-filter-fab" [class.hidden]="isMobileFiltersOpen()" (click)="toggleMobileFilters()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            @if (isMobileFiltersOpen()) {
            <polyline points="9 18 15 12 9 6"></polyline>
            } @else {
            <polyline points="15 18 9 12 15 6"></polyline>
            }
        </svg>
    </button>

    <!-- Mobile filter sidebar -->
    <div class="mobile-filter-sidebar" [class.open]="isMobileFiltersOpen()">
        <div class="mobile-filter-header">
            <h3>{{'MAP.FILTERS' | translate}}</h3>
            <button class="close-btn" (click)="closeMobileFilters()" type="button">✕</button>
        </div>

        <div class="mobile-sidebar-section">
            <label class="section-label">{{'MAP.CATEGORIES' | translate}}</label>
            <div class="mobile-filter-content">
                @for (category of categories; track $index) {
                <button class="mobile-filter-item" [class.active]="selectedCategories.has(category)"
                    (click)="selectedCategory(category)">
                    <img [src]="'assets/icons/' + getCategoryIcon(category) + '.png'" [alt]="getCategoryLabel(category)"
                        class="filter-icon" width="20" height="20" onerror="this.style.display='none'">
                    {{getCategoryLabel(category)}}
                </button>
                }
            </div>
        </div>

        <div class="mobile-sidebar-section">
            <label class="section-label">{{'MAP.UTILITIES' | translate}}</label>
            <div class="mobile-filter-content">
                <button class="mobile-filter-item" [class.active]="zoom" (click)="activateZoom()">
                    {{zoomText}}
                </button>
                <button class="mobile-filter-item" [class.active]="toponymyVisible()" (click)="toggleToponymy()">
                    {{'MAP.TOPONYMY' | translate}}
                </button>
                <button class="mobile-filter-item" [class.active]="streetsVisible()" (click)="toggleStreets()">
                    {{'MAP.ROADS' | translate}}
                </button>
            </div>
        </div>
    </div>

    <!-- Overlay -->
    @if (isMobileFiltersOpen()) {
    <div class="mobile-filter-overlay" (click)="closeMobileFilters()"></div>
    }

</div>